module.exports = __webpack_public_path__ + "static/og-2d22b555cbd1aafaaa4120e8e47f1893.png";